import { searchActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import { log } from '_services'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [searchActions.searchSuccess]: (state, action) => {
        let result;
        action.payload.entities.results ? result = action.payload.entities.results : result = {};
        return result;
    },
    [searchActions.searchFailure]: (state, action) => {
        log.error('Error performing search.  searchStr: ' + action.payload.searchStr + ' page: ' + action.payload.page + ' error: ' + action.payload.error);
    },
    [searchActions.quickSearchClear]: (state, action) => {
        let result;
        result = {};
        return result;
    },

})